<template>
  <div id="stickyBar">
    <v-app-bar 
      class="v-app-bar-fixed-mobile" 
      :color="NOTARIA.Theme.DatosContacto.StickyBarCSS.BackgroundColor" 
      height="auto"
      min-height="30"
      :absolute="!NOTARIA.Theme.DatosContacto.Fixed"
    >
      <v-container class="pa-0 ma-0 fill-height" fluid>
        <div class="d-flex justify-space-between align-center w-100 stickybar-text px-4" style="height: 100%;">
          
          <!-- Left Side: Phone & Address -->
          <div class="d-flex align-center text-truncate">
            <!-- Telefono -->
            <a v-if="NOTARIA.Contacto.Telefono && NOTARIA.Theme.DatosContacto.MostrarTelefono" 
               :href="'tel:' + NOTARIA.Contacto.Telefono"
               :title="'Marcar telefono de la notaría: ' + NOTARIA.Contacto.Telefono"
               class="text-decoration-none d-flex align-center text-truncate mr-4"
               :style="{
                 color: NOTARIA.Theme.DatosContacto.Letra.Color,
                 fontFamily: NOTARIA.Theme.DatosContacto.Letra.Font,
                 fontSize: NOTARIA.Theme.DatosContacto.Letra.Size,
                 fontWeight: NOTARIA.Theme.DatosContacto.Letra.Weight
               }">
              <v-icon class="mr-1" small :color="NOTARIA.Theme.DatosContacto.Letra.Color">mdi-phone</v-icon>
              <span>{{ NOTARIA.Contacto.Telefono }}</span>
            </a>

            <!-- Separador -->
            <span class="d-none d-md-inline mr-4" 
               v-if="(NOTARIA.Contacto.Telefono && NOTARIA.Theme.DatosContacto.MostrarTelefono) && (NOTARIA.Contacto.Direccion && NOTARIA.Theme.DatosContacto.MostrarDireccion)"
               :style="{ color: NOTARIA.Theme.DatosContacto.Letra.Color }">|</span>

            <!-- Direccion -->
            <a v-if="NOTARIA.Contacto.Direccion && NOTARIA.Theme.DatosContacto.MostrarDireccion" 
               :href="NOTARIA.Contacto.EnlaceMaps" 
               title="Abrir dirección de la notaría en google maps" 
               target="_blank"
               class="text-decoration-none d-none d-md-flex align-center text-truncate"
               :style="{
                 color: NOTARIA.Theme.DatosContacto.Letra.Color,
                 fontFamily: NOTARIA.Theme.DatosContacto.Letra.Font,
                 fontSize: NOTARIA.Theme.DatosContacto.Letra.Size,
                 fontWeight: NOTARIA.Theme.DatosContacto.Letra.Weight
               }">
              <v-icon class="mr-1" small :color="NOTARIA.Theme.DatosContacto.Letra.Color">mdi-map-marker</v-icon>
              <span class="text-truncate" style="max-width: 500px;">
                {{ NOTARIA.Contacto.Direccion }} {{ NOTARIA.Contacto.CP }}, {{ NOTARIA.Contacto.Municipio }}, {{ NOTARIA.Contacto.Provincia }}
              </span>
            </a>
          </div>

          <!-- Right Side: Email -->
          <div class="d-flex align-center justify-end text-truncate pl-4"
               v-if="(NOTARIA.Contacto.Email && NOTARIA.Theme.DatosContacto.MostrarEmail) || (NOTARIA.Contacto.Email2 && NOTARIA.Theme.DatosContacto.MostrarEmail2)">
            <v-icon class="mr-1" small :color="NOTARIA.Theme.DatosContacto.Letra.Color">mdi-email</v-icon>
            <a v-if="NOTARIA.Contacto.Email && NOTARIA.Theme.DatosContacto.MostrarEmail" 
               :href="'mailto:' + NOTARIA.Contacto.Email"
               :title="'Enviar correo electronico a la dirección de la notaría: ' + NOTARIA.Contacto.Email" 
               class="text-decoration-none d-flex align-center text-truncate"
               :style="{
                 color: NOTARIA.Theme.DatosContacto.Letra.Color,
                 fontFamily: NOTARIA.Theme.DatosContacto.Letra.Font,
                 fontSize: NOTARIA.Theme.DatosContacto.Letra.Size,
                 fontWeight: NOTARIA.Theme.DatosContacto.Letra.Weight
               }">
               <span>{{ NOTARIA.Contacto.Email }}</span>
            </a>
            <span class="mx-2 d-none d-md-inline" 
                v-if="(NOTARIA.Contacto.Email && NOTARIA.Theme.DatosContacto.MostrarEmail) && (NOTARIA.Contacto.Email2 && NOTARIA.Theme.DatosContacto.MostrarEmail2)"
                :style="{ color: NOTARIA.Theme.DatosContacto.Letra.Color }">|</span>
            <a v-if="NOTARIA.Contacto.Email2 && NOTARIA.Theme.DatosContacto.MostrarEmail2" 
               :href="'mailto:' + NOTARIA.Contacto.Email2"
               :title="'Enviar correo electronico a la dirección de la notaría: ' + NOTARIA.Contacto.Email2" 
               class="text-decoration-none d-none d-md-flex align-center text-truncate"
               :style="{
                 color: NOTARIA.Theme.DatosContacto.Letra.Color,
                 fontFamily: NOTARIA.Theme.DatosContacto.Letra.Font,
                 fontSize: NOTARIA.Theme.DatosContacto.Letra.Size,
                 fontWeight: NOTARIA.Theme.DatosContacto.Letra.Weight
               }">
               <span>{{ NOTARIA.Contacto.Email2 }}</span>
            </a>
          </div>

        </div>
      </v-container>
    </v-app-bar>
  </div>
</template>
<script setup lang="ts">
import { useStore } from '../store'
const store = useStore();
const { NOTARIA } = storeToRefs(store)

</script>
<style lang="css" scoped>
.v-app-bar-fixed-mobile .stickybar-text{
  height: 30px !important;
  z-index: 99999;
  font-size: calc(0.5em + 0.4vw) !important;
  line-height: calc(0.5em + 1.6vw) !important;
  vertical-align: top;
}
.stickybar-text{
  /* text-overflow: ellipsis;
  overflow: hidden; */
}
</style>